// Rutas de Presupuestos. Viven aparte de `config.tsx` porque las usan las mismas
// secciones que `config.tsx` importa (evita el ciclo de imports).

/** Id y ruta de «Desglose»: el formulario y las líneas de presupuesto. */
export const BUDGET_LINES_ID = "budget-lines";
/** «Dashboard»: la ruta de siempre de Presupuestos (los enlaces viejos siguen sirviendo). */
export const BUDGETS_DASHBOARD_PATH = "/expenses/budgets";
export const BUDGET_LINES_PATH = `/expenses/${BUDGET_LINES_ID}`;
/** `?new=1` en Desglose: llega con el formulario a la vista y el foco en él. */
export const BUDGET_LINES_NEW_PARAM = "new";
export const BUDGET_LINES_NEW_PATH = `${BUDGET_LINES_PATH}?${BUDGET_LINES_NEW_PARAM}=1`;
